<template>
    <MaterialYield></MaterialYield>
</template>

<script>
import { defineAsyncComponent } from "vue";

// Import components using dynamic imports
const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const MaterialYield = defineAsyncComponent(() =>
    import("../../components/ProjectManagement/MaterialYield/MaterialYield.vue")
);
export default {
    name: "Project_MaterialYield",
    components: { MaterialYield, AuthLayout },
};
</script>
